import { render } from "./CalculatorBasePerk.vue?vue&type=template&id=30541d0a&ts=true"
import script from "./CalculatorBasePerk.vue?vue&type=script&lang=ts"
export * from "./CalculatorBasePerk.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__